function visibleAssetId(asset) {
  if (!asset?._id || asset.restricted) {
    return null;
  }
  return asset._id;
}

export default function getEventAssetIds(event, limit = 5) {
  const assets = event?.data?.assets;
  if (Array.isArray(assets) && assets.length) {
    return assets.map(visibleAssetId).filter(Boolean).slice(0, limit);
  }
  const assetId = visibleAssetId(event?.data?.asset);
  return assetId ? [assetId] : [];
}
